var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_spark_auctionedge_com_apps_spark_remoteEntry_js_63efc2a0__;